import { createReducer, on } from '@ngrx/store';
import { BannersActions } from '../_actions/banners.actions';
import { BannerModel } from '../../_models/banner.model';

export interface BannersState {
  banners: ReadonlyArray<BannerModel>;
  loading: boolean;
  error: any;
}

export const initialStateBanners: BannersState = {
  banners: [],
  loading: false,
  error: null,
};

export const bannersReducer = createReducer(
  initialStateBanners,
  on(BannersActions.loadActiveBanners, (state) => ({
    ...state,
    loading: true,
  })),
  on(BannersActions.loadActiveBannersSuccess, (state, { banners }) => ({
    ...state,
    banners,
    loading: false,
    error: null,
  })),
  on(BannersActions.loadActiveBannersFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  }))
);
